import modal from "modal";
import Bacon from "Bacon";
import $ from "jquery";
import c from "common";
import ajax from "ajax";
import ga from "analytics";

function doCreateFolderAjax(folderData, errorHandler) {
  return ajax.stream({
    url: "/tallenteet/api/folder",
    type: "PUT",
    contentType: "application/json",
    data: JSON.stringify(folderData)
  }, errorHandler);
}

function doCreateFolderDeprecatedAjax(folderData, errorHandler) {
  return ajax.stream({
    url: "/tallenteet/api/folder-deprecated",
    type: "PUT",
    contentType: "application/json",
    data: JSON.stringify(folderData)
  }, errorHandler);
}

function getCreateFolderModalValues() {
  return {
    parentId: $('.recordings-folder.navitem-selected').attr("data-id"),
    folderName: $('#folder-name-input').val()
  };
}

function getValidationFailedTipProps(id) {
  return {
    id: id,
    content: "Kansion nimi ei saa olla tyhjä, eikä se saa sisältää HTML-elementtejä.",
    show: 'mouseover',
    hide: 'mouseout inactive'
  };
}

function isValidFolderName(folderName) {
  return !/(<([^>]+)>)/ig.test(folderName) && folderName.length <= 64;
}

function validateFolderNameInModal() {
  var isFolderNameValid = isValidFolderName(getCreateFolderModalValues().folderName);
  if (isFolderNameValid) {
    validationSuccessUI();
  } else {
    validationFailUI();
    ga.trackWithSection("validateFolderName", "fail", getCreateFolderModalValues().folderName);
  }
}

function validateFolderNameOnAjax() {
  if (isValidFolderName(getCreateFolderModalValues().folderName) && "" !== getCreateFolderModalValues().folderName.trim()) {
    return true;
  } else {
    validationFailUI();
    ga.trackWithSection("validateFolderName", "fail", getCreateFolderModalValues().folderName);
    return false;
  }
}

function validationSuccessUI() {
  $("#folder-name-input").removeClass("error");
  $("#folder-name-input").qtip("disable");
  $("#qtip-createFolderQTip").hide();
}

function validationFailUI() {
  $("#folder-name-input").addClass("error");
  $("#folder-name-input").qtip(getValidationFailedTipProps("createFolderQTip"));
}

function bindFolderNameValidator() {
  $('#folder-name-input').on("change input", validateFolderNameInModal);
}

function parseNewFolderId(folderTree, newFolderName) {
  var folders = folderTree.folders[0].folders;
  var filteredFolders = folders.filter(function (folder) {
    return folder.name === newFolderName;
  });
  var folderIds = filteredFolders.map(function (folder) {
    return folder.id;
  });
  // Select newest ID as multiple folders might have the same name
  return Math.max.apply(null, folderIds);
}

$(document.body).asEventStream('click', '.create-folder-cancel').doAction(c.stopEvent).onValue(modal.close);

export default {
  create: doCreateFolderAjax,
  createDeprecated: doCreateFolderDeprecatedAjax,
  isValidFolderName: isValidFolderName,
  validationFailedTip: getValidationFailedTipProps,
  parseNewFolderId: parseNewFolderId,
  open: function (options) {
    options.modalClass = "create-folder-modal";
    return modal.open("create-folder-modal", Bacon.combineTemplate(options)).doAction(modal.center).doAction(bindFolderNameValidator).flatMap(function () {
      return $("#create-folder-form").asEventStream('submit').doAction(c.stopEvent).map(true);
    }).map(validateFolderNameOnAjax).filter(c.isTrue).merge(modal.closeStream.map(false)).take(1).filter(c.isTrue).map(getCreateFolderModalValues).doAction(modal.close);
  }
};



// WEBPACK FOOTER //
// ./web/js/create-folder.js